<div mat-dialog-title>
  <span>{{ title }}</span>
  <q9-dialog-close-button [disabled]="processing"></q9-dialog-close-button>
</div>

<mat-dialog-content class="content">
  <p>{{ message }}</p>
  <q9-info-message *ngIf="warningMessage" type="warn">* {{ warningMessage }}</q9-info-message>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button [isLoading]="processing" (click)="confirm()">
    {{ confirmButtonText }}
  </q9-primary-button>
</mat-dialog-actions>
